<template>
  <div id="app">
    <!-- Login/logout/404 render full-screen; everything else gets the nav chrome. -->
    <template-default v-if="showChrome">
      <router-view />
    </template-default>
    <router-view v-else />
  </div>
</template>

<script>
import { mapState } from 'vuex'

const BARE_ROUTES = ['Login', 'Logout', 'NotFound']

export default {
  computed: {
    ...mapState('ui', ['toast']),
    showChrome() {
      return !BARE_ROUTES.includes(this.$route.name)
    },
  },
  watch: {
    // Bridge the ui store's toast state to vue-toast-notification.
    toast(t) {
      if (t && t.message)
        this.$toast.open({ message: t.message, type: t.type || 'info' })
    },
  },
}
</script>

<style lang="scss"></style>
